var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketBoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.445,
    height: 117.044,
    viewBox: "0 0 108.445 117.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2607",
    "data-name": "Grupo 2607",
    transform: "translate(-1678.137 -904.391)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_114",
    "data-name": "Elipse 114",
    cx: 48.5,
    cy: 48,
    rx: 48.5,
    ry: 48,
    transform: "translate(1678.137 904.391)",
    fill: "#ff3c9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_27",
    "data-name": "Pol\\xEDgono 27",
    d: "M24.175,0,48.35,41.6H0Z",
    transform: "translate(1786.582 979.563) rotate(120)",
    fill: "#ff3c9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M36.711,28.164v5.06A3.373,3.373,0,0,1,33.035,36.6,33.378,33.378,0,0,1,18.479,31.42,32.889,32.889,0,0,1,8.359,21.3,33.378,33.378,0,0,1,3.182,6.677,3.373,3.373,0,0,1,6.538,3H11.6a3.373,3.373,0,0,1,3.373,2.9,21.656,21.656,0,0,0,1.181,4.739,3.373,3.373,0,0,1-.759,3.559l-2.142,2.142a26.986,26.986,0,0,0,10.12,10.12l2.142-2.142a3.373,3.373,0,0,1,3.559-.759,21.656,21.656,0,0,0,4.739,1.181,3.373,3.373,0,0,1,2.9,3.424Z",
    transform: "translate(1706.437 932.625)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketBoto);
export default __webpack_public_path__ + "static/media/ticket_botão.3288f2c8212f19bc96f88c5c8fcadefb.svg";
export { ForwardRef as ReactComponent };